import { render, staticRenderFns } from "./QuoteLimitUpperRuleDia.vue?vue&type=template&id=bbd912a0&scoped=true"
import script from "./QuoteLimitUpperRuleDia.vue?vue&type=script&lang=js"
export * from "./QuoteLimitUpperRuleDia.vue?vue&type=script&lang=js"
import style0 from "./QuoteLimitUpperRuleDia.vue?vue&type=style&index=0&id=bbd912a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd912a0",
  null
  
)

export default component.exports